import React from 'react';
import { Download, Filter, Plus } from 'lucide-react';
import Button from '../components/atoms/Button';

// Demo response for GET /api/labelfields/:id. Replace this constant with the API response.
const demoLabelFields = [
  { id: 1, label: 'Name', key: 'name' },
  { id: 2, label: 'Email', key: 'email' },
  { id: 3, label: 'Query Type', key: 'queryType' },
  { id: 4, label: 'Description', key: 'description' },
  { id: 5, label: 'Employee', key: 'employee' },
  { id: 6, label: 'Status', key: 'status' },
  { id: 7, label: 'Escalation To', key: 'escalationTo' },
];

// Demo response for the query records API. The label-field id is ready for future requests.
const demoTableData = [
  { id: 1, name: 'Rajesh Kumar', email: 'rajesh@gmail.com', queryType: 'shift_timing', description: 'Need to upload hono hr app in new phone Emp id- 90998989', employee: 'Employee', status: 'Status', escalationTo: 'Level 1' },
  { id: 2, name: 'Deepanshu', email: 'deepanshu@gmail.com', queryType: 'shift_timing', description: 'Need to upload hono hr app in new phone Emp id- 90998989', employee: 'Employee', status: 'Status', escalationTo: 'Level 1' },
  { id: 3, name: 'Ritik Kumar', email: 'ritik@gmail.com', queryType: 'shift_timing', description: 'Need to upload hono hr app in new phone Emp id- 90998989', employee: 'Employee', status: 'Status', escalationTo: 'Level 1' },
  { id: 4, name: 'Raj Kumar', email: 'raj@gmail.com', queryType: 'shift_timing', description: 'Need to upload hono hr app in new phone Emp id- 90998989', employee: 'Employee', status: 'Status', escalationTo: 'Level 1' },
];

const labelFieldId = 44;

export default function QueryTable({ id = labelFieldId, labelFields = demoLabelFields, tableData = demoTableData }) {
  return (
    <section className="ca-query-table" aria-label="Query records">
      <div className="ca-query-table__toolbar">
        <label className="ca-query-table__filter">
          <Filter size={14} aria-hidden="true" />
          <span className="ca-query-table__sr-only">Filter by status</span>
          <select defaultValue="all" aria-label="Filter by status">
            <option value="all">Select Status</option>
            <option value="open">Open</option>
            <option value="closed">Closed</option>
          </select>
        </label>
        <div className="ca-query-table__actions">
          <Button variant="outline" size="sm" startIcon={<Plus size={14} />}>
            New Query
          </Button>
          <Button variant="outline" size="sm" startIcon={<Download size={14} />}>
            Download Report
          </Button>
        </div>
      </div>

      <div className="ca-query-table__scroll" data-label-field-id={id}>
        <table>
          <thead>
            <tr>
              <th scope="col">#</th>
              {labelFields.map((field) => (
                <th scope="col" key={field.id}>{field.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={row.id ?? index}>
                <td>{index + 1}</td>
                {labelFields.map((field) => (
                  <td key={`${row.id ?? index}-${field.id}`}>
                    {row[field.key] ?? '-'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}